import { demoCustomerStoriesBlock } from "@/lib/content-blocks-data";
import { CustomerStoriesSection } from "./customer-stories-section";

export function TestimonialBand() {
  return <CustomerStoriesSection block={demoCustomerStoriesBlock} />;
}
